import { render, staticRenderFns } from "./user-report-details.vue?vue&type=template&id=317db9c5"
import script from "./user-report-details.vue?vue&type=script&lang=js"
export * from "./user-report-details.vue?vue&type=script&lang=js"
import style0 from "./user-report-details.vue?vue&type=style&index=0&id=317db9c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports